import {
  CONTACT_BATCH_GET_FAIL,
  CONTACT_BATCH_GET_REQUEST,
  CONTACT_BATCH_GET_SUCCESS,
} from "../Constant/StudyBatchConstant";
import api from "../Core/api";

export const get_contact_batch = () => async (dispatch) => {
  try {
    dispatch({ type: CONTACT_BATCH_GET_REQUEST });
    const { data } = await api.get("/student/studybatch");

    dispatch({ type: CONTACT_BATCH_GET_SUCCESS, payload: data?.Result });
  } catch (error) {
    dispatch({
      type: CONTACT_BATCH_GET_FAIL,
      payload:
        error.response && error.response.data.Result
          ? error.response.data.Result
          : error.message,
    });
  }
};
